import { Component, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/routable/home/home.component';
import { SettingsComponent } from './components/routable/settings/settings.component';
import { ProfileComponent } from './components/routable/profile/profile.component';
import { LoginComponent } from './components/routable/login/login.component';
import { LoginCallbackComponent } from './components/login-callback/login-callback.component';
import { NavletComponent } from './components/routable/navlet/navlet.component';
import { UsersComponent } from './components/routable/identity/users/users.component';
import { UserComponent } from './components/routable/identity/user/user.component';
import { RolesComponent } from './components/routable/identity/roles/roles.component';
import { RoleComponent } from './components/routable/identity/role/role.component';
import { NodeComponent } from './components/routable/app-core/node/node.component';
import { TextSearchFieldComponent } from './components/fragments/text-search-field/text-search-field.component';
import { PendingChangesGuardService } from './services/pending-changes-guard/pending-changes-guard.service';
import { ClaimTypeComponent } from './components/routable/identity/claim-type/claim-type.component';
import { ClaimTypesComponent } from './components/routable/identity/claim-types/claim-types.component';
import { PersonsComponent } from './components/routable/app-core/persons/persons.component';
import { PersonComponent } from './components/routable/app-core/person/person.component';
import { ResourcesComponent } from './components/routable/talent-core/resources/resources.component';
import { ResourceComponent } from './components/routable/talent-core/resource/resource.component';
import { ProductionsComponent } from './components/routable/talent-core/productions/productions.component';
import { ProductionComponent } from './components/routable/talent-core/production/production.component';
import { EditorComponent } from './components/base/editor/editor.component';
import { SearchComponent } from './components/base/search/search.component';
import { OrganizationsComponent } from './components/routable/app-core/organizations/organizations.component';
import { OrganizationComponent } from './components/routable/app-core/organization/organization.component';
import { TalentStartComponent } from './components/routable/talent-core/talent-start/talent-start.component';
import { EngagementsComponent } from './components/routable/talent-core/engagements/engagements.component';
import { EngagementComponent } from './components/routable/talent-core/engagement/engagement.component';
import { ActingProfilesComponent } from './components/routable/talent-core/acting-profiles/acting-profiles.component';
import { ActingProfileComponent } from './components/routable/talent-core/acting-profile/acting-profile.component';
import { SearchRequestsComponent } from './components/routable/app-core/search-requests/search-requests.component';
import { SearchRequestComponent } from './components/routable/app-core/search-request/search-request.component';
import { GroupsComponent } from './components/routable/app-core/groups/groups.component';
import { GroupComponent } from './components/routable/app-core/group/group.component';
import { TasksComponent } from './components/routable/app-core/tasks/tasks.component';
import { TaskComponent } from './components/routable/app-core/task/task.component';
import { MessageComponent } from './components/routable/messages/message/message.component';
import { MessagesComponent } from './components/routable/messages/messages/messages.component';
import { ContactsComponent } from './components/routable/app-core/contacts/contacts.component';
import { ContactComponent } from './components/routable/app-core/contact/contact.component';
import { VenuePersonSettingsComponent } from './components/routable/app-core/venue-person-settings/venue-person-settings.component';
import { HtmlContentsComponent } from './components/routable/app-core/html-contents/html-contents.component';
import { HtmlContentComponent } from './components/routable/app-core/html-content/html-content.component';
import { EmailMessagesComponent } from './components/routable/messages/email-messages/email-messages.component';
import { EmailMessageComponent } from './components/routable/messages/email-message/email-message.component';
import { TextMessagesComponent } from './components/routable/messages/text-messages/text-messages.component';
import { TextMessageComponent } from './components/routable/messages/text-message/text-message.component';
import { HtmlContentViewerComponent } from './components/routable/app-core/html-content-viewer/html-content-viewer.component';
import { AuthGuardService } from './services/auth/auth-guard.service';
import { ProductsComponent } from './components/routable/commerce/products/products.component';
import { ProductComponent } from './components/routable/commerce/product/product.component';
import { ProductCardsComponent } from './components/routable/commerce/product-cards/product-cards.component';
import { ArticleCardsComponent } from './components/routable/app-core/article-cards/article-cards.component';

const routes: Routes = [
    { path: '', component: HomeComponent, pathMatch: 'full' },
    { path: 'subscribe', component: HomeComponent },
    { path: 'at/:themename', component: HomeComponent, pathMatch: 'full' },
    { path: 'login', component: LoginComponent },
    { path: 'logincallback/:authprovidername', component: LoginCallbackComponent },
    { path: 'settings', component: SettingsComponent },
    { path: 'profile', component: ProfileComponent },
    { path: 'users', component: UsersComponent },
    { path: 'user/:id', component: UserComponent, canDeactivate: [PendingChangesGuardService] },
    { path: 'user/:id/revision/:number', component: UserComponent },
    { path: 'roles', component: RolesComponent },
    { path: 'role/:id', component: RoleComponent, canDeactivate: [PendingChangesGuardService] },
    { path: 'role/:id/revision/:number', component: RoleComponent },
    { path: 'node/:id', component: NodeComponent, canDeactivate: [PendingChangesGuardService] },
    { path: 'node/:id/:parentid', component: NodeComponent },
    { path: 'node/:id/revision/:number', component: NodeComponent },
    { path: 'claimtypes', component: ClaimTypesComponent },
    { path: 'claimtype/:id', component: ClaimTypeComponent, canDeactivate: [PendingChangesGuardService] },
    { path: 'claimtype/:id/revision/:number', component: ClaimTypeComponent },
    { path: 'navlet/:nodeid', component: NavletComponent },
    { path: 'people', component: PersonsComponent },
    { path: 'person/:id', component: PersonComponent, canDeactivate: [PendingChangesGuardService] },
    { path: 'textsearchfield', component: TextSearchFieldComponent },
    { path: 'resources', component: ResourcesComponent },
    { path: 'resource/:id', component: ResourceComponent, canDeactivate: [PendingChangesGuardService] },
    { path: 'resource/:id/revision/:number', component: ResourceComponent },
    { path: 'productions', component: ProductionsComponent },
    { path: 'production/:id', component: ProductionComponent, canDeactivate: [PendingChangesGuardService] },
    { path: 'production/:id/revision/:number', component: ProductionComponent },
    { path: 'editor/:id', component: EditorComponent },
    { path: 'search', component: SearchComponent },
    { path: 'orgs', component: OrganizationsComponent },
    { path: 'org/:id', component: OrganizationComponent, canDeactivate: [PendingChangesGuardService] },
    { path: 'org/:id/revision/:number', component: OrganizationComponent },
    { path: 'talentcore', component: TalentStartComponent },
    { path: 'engagements', component: EngagementsComponent },
    { path: 'engagement/:id', component: EngagementComponent },
    { path: 'engagement/:id/revision/:number', component: EngagementComponent },
    { path: 'actingprofiles', component: ActingProfilesComponent },
    { path: 'actingprofile/:id', component: ActingProfileComponent },
    { path: 'searchrequests', component: SearchRequestsComponent },
    { path: 'searchrequest/:id', component: SearchRequestComponent },
    { path: 'groups', component: GroupsComponent },
    { path: 'group/:id', component: GroupComponent },
    { path: 'tasks', component: TasksComponent },
    { path: 'task/:id', component: TaskComponent },
    { path: 'messages', component: MessagesComponent },
    { path: 'message/:id', component: MessageComponent },
    { path: 'contacts', component: ContactsComponent },
    { path: 'contact/:id', component: ContactComponent },
    { path: 'venuesettings', component: VenuePersonSettingsComponent, canActivate: [AuthGuardService] },
    { path: 'contents', component: HtmlContentsComponent },
    { path: 'content/:id', component: HtmlContentComponent },
    { path: 'view/:id', component: HtmlContentViewerComponent },
    { path: 'read/:moniker', component: HtmlContentViewerComponent },
    { path: 'emailmessages', component: EmailMessagesComponent },
    { path: 'emailmessage/:id', component: EmailMessageComponent },
    { path: 'textmessages', component: TextMessagesComponent },
    { path: 'textmessage/:id', component: TextMessageComponent },
    { path: 'products', component: ProductsComponent },
    { path: 'product/:id', component: ProductComponent },
    { path: 'bakedgoods', component: ProductCardsComponent },
    { path: 'merchandise', component: ProductCardsComponent },
    { path: 'newz', component: ArticleCardsComponent }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})

export class AppRoutingModule { }
